var React = require('react');

function Microphone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32,46.5A10.456,10.456,0,0,0,42.465,36L42.5,15a10.5,10.5,0,1,0-21,0V36A10.486,10.486,0,0,0,32,46.5ZM50.55,36c0,10.5-8.89,17.85-18.55,17.85S13.45,46.5,13.45,36H7.5c0,11.97,9.52,21.805,21,23.52V71h7V59.52c11.48-1.68,21-11.55,21-23.52Z","transform":"translate(-6 -3)","fill":"none","stroke":"#fff","strokeWidth":"3"}));
}

Microphone.defaultProps = {"width":"52","height":"69.5","viewBox":"0 0 52 69.5"};

module.exports = Microphone;

Microphone.default = Microphone;
